import type { LanguageType } from "./types";

export const LanguageNameMap: Record<LanguageType, string> = {
  PYTHON: "Python",
  JAVASCRIPT: "JavaScript",
  CURL: "Curl",
  BASH: "Bash",
};

/** Dashboard / API snippet editors (excludes CURL). */
export const languages: LanguageType[] = ["PYTHON", "JAVASCRIPT"];

/** Share popover and any UI that includes curl snippets. */
export const snippetLanguages: LanguageType[] = ["PYTHON", "JAVASCRIPT", "CURL"];
